import React from 'react';
import { Pencil, CalendarOff, CalendarPlus } from 'lucide-react';
import { format } from 'date-fns';
import { createPortal } from 'react-dom';
import DateTimePicker from './DateTimePicker';


export function RdvPassageInline({ p, onEdit, onClear }) {
  return (
    <>
      {p.date_rdv ? format(new Date(p.date_rdv), 'dd/MM/yyyy HH:mm') : 'Sans RDV'}
      {p.date_rdv ? (
        <>
          <button onClick={() => onEdit(p)} title="Modifier le rendez-vous">
            <Pencil size={17} className="text-blue-600" />
          </button>
          <button onClick={() => onClear(p.id)} title="Supprimer le rendez-vous">
            <CalendarOff size={17} className="text-red-600" />
          </button>
        </>
      ) : (
        <button onClick={() => onEdit(p)} title="Modifier le rendez-vous">
          <CalendarPlus size={17} className="text-green-600" />
        </button>
      )}
    </>
  );
}
export function RdvPassageModal({ passage, onConfirm, onClose }) {
  if (!passage) return null;

  return createPortal(
    <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative z-10 w-max[80vw] md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 gap-2">
        <DateTimePicker
          initialValue={passage?.date_rdv}
          onConfirm={(datetime) => {
            onConfirm(passage.id, datetime);
            onClose();
          }}
          onCancel={onClose}
        />
      </div>
    </div>,
    document.body,
  );
}

/*
export  function RdvPassagePanel({ p, setPatients }) {
  const API = (CONFIG.API_URL || '/api').replace(/\/+$/, '');
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  const [editRdvTime, setEditRdvTime] = useState(false);
  const [editedPassage, setEditedPassage] = useState(null);

  async function handleRDVChange(id, value) {
    try {
      const res = await fetch(`${API}/passages/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ date_rdv: value || null }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const p = mapDbPatient(await res.json());
      setPatients((prev) => prev.map((x) => (x.id === p.id ? p : x)));
    } catch (err) {
      console.error('rdv update error :', err);
      alert('Impossible de modifier le Rendez-vous : ' + err.message);
    }
  }

  function rdvTimeConfirm(datetime) {
    handleRDVChange(editedPassage.id, datetime);
  }

  return (
    <>
      {editRdvTime &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => {
                setEditedPassage(null);
                setEditRdvTime(false);
              }}
            />
            <div className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 gap-2">
              <DateTimePicker
                initialValue={editedPassage?.date_rdv}
                onConfirm={(datetime) => {
                  rdvTimeConfirm(datetime);
                  setEditRdvTime(false);
                  setEditedPassage(null);
                }}
                onCancel={() => {
                  setEditRdvTime(false);
                  setEditedPassage(null);
                }}
              />
            </div>
          </div>,
          document.body,
        )}
      {p.date_rdv ? format(new Date(p.date_rdv), 'dd/MM/yyyy HH:mm') : 'Sans RDV'}
      {p.date_rdv ? (
        <>
          <button
            onClick={() => {
              setEditedPassage(p);
              setEditRdvTime(true);
            }}
            title="Modifier le rendez-vous"
          >
            <Pencil size={17} className="text-blue-600" />
          </button>
          <button
            onClick={() => {
              handleRDVChange(p.id, null);
            }}
            title="Supprimer le rendez-vous"
          >
            <CalendarOff size={17} className="text-red-600" />
          </button>
        </>
      ) : (
        <button
          onClick={() => {
            setEditedPassage(p);
            setEditRdvTime(true);
          }}
          title="Modifier le rendez-vous"
        >
          <CalendarPlus size={17} className="text-green-600" />
        </button>
      )}
    </>
  );
}

*/